import { get, post } from '../lib'

export interface CurrentUserResponse {
  id: string
  roles: string[]
  profile: UserDetail
  permissions: ResourcePermission[]
}

export type Preferences = {
  [key: string]: {
    id: number
    val: string | number | boolean
  }
}

type Organization = {
  id: number
  name: string
  deleteFlag: boolean
}

type LegacyUser = {
  id: number
  username: string
  firstName: string
  lastName: string
  email: string | null
  administrator: boolean
  organizations: Organization[]
  ldapUser: boolean
  permissions: ResourcePermission[]
  preferences: Preferences
  ipa: boolean
}

export type ResourcePermission = {
  id: string
  type: string
  isOwner: boolean
  permissions: Permission[]
}

export interface Permission {
  read: boolean
  create: boolean
  update: boolean
  delete: boolean

  uploads: {
    read: boolean
    write: boolean
  }

  location: {
    read: boolean
    write: boolean
  }
}

export type UserDetail = {
  user_id?: string
  first_name: string
  last_name: string
  username: string
  email: string | null
}

export interface Group {
  id: number
  name: string
  organization: Organization
}

export interface Notification {
  id: number
}

export interface User {
  id: number
  _href: string
  administrator: boolean
  isOrganizationAdministrator: boolean
  dateCreated: string
  firstName: string
  lastName: string
  username: string
  email: string | null
  passwordExpired: boolean
  accountExpired: boolean
  accountLocked: boolean
  ssoEnabled: boolean
  ssoId: string | null
  ipa: boolean
  version: number
  disableDate: string | null
  failedAttempts: number
  lastActive: string | null
  enabled: boolean
  organizations: Organization[]
  groups: Group[]
  notifications: Notification[]
}

export const getUser = async (token): Promise<CurrentUserResponse> => {
  return post<
    {
      type: string
      auth_string: string
    },
    CurrentUserResponse
  >({
    path: '/auth/authorization/verify/token',
    token,
    body: {
      type: 'token',
      auth_string: token
    }
  })
}

export const getLegacyUser = async (token: string): Promise<LegacyUser> => {
  return await get({
    path: '/api/v1/currentUser',
    token
  })
}

export const getAllUsers = async (): Promise<User[]> => {
  return get<User[]>({
    path: `/api/v1/users`
  })
}
